module.exports = __webpack_public_path__ + "img/home_active.daf0b61b.svg";